import React from 'react';
import './CategoryCard.scss';
import { Link } from 'react-router-dom';
import routes from '../constants/routes';

function CategoryCard(props) {
  const { postItem } = props;
  /*
    id: "25137336-cc9d-4d40-a196-2cdbb4f302ac",
    name: "Events",
    description: "Top jewelry brands",
    offerCount: 1,
    image:
    "https://dev-cdn-offer.fonepay.com/offercontent/sub_merchant_category/f7885a5459c44d4a9cb37c59ca1b375f" // /img/photo-2.png
  */
  return (
    <div className='card-popular-categories'>
      {/* <div className='categories clearfix'> */}
      <Link
        className='d-block'
        to={`${routes['offers']}?category=${postItem.id}`}
      >
        <div className='brand-items float-right'>
          <img src={postItem.image} alt='' />
        </div>
        <div className='brand float-left'>
          <h4>{postItem.name}</h4>
          <small>{postItem.offerCount} offers</small>
        </div>
      </Link>
      {/* </div> */}
    </div>
  );
}

export default CategoryCard;
